export default __webpack_public_path__ + "1fbbec55b4c17a0e502b213b75773e36.svg";